import * as React from "react";
import OverlaySpinner from "../../../Loaders/OverlaySpinner";
import TextInputField from "../../Base/Fields/TextInputField";
import Modal from "../../Base/Modals/Modal";

import CheckField from "../../Base/Fields/CheckField";
import {
  useIndexTableForm,
  constants,
  create,
  update,
  detailUrl,
} from "../../../../store/indexTable";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setActiveFormInstance } from "../../../../store/base";

export default function IndexTableModalForm({
  method,
  id,
  closeFunction,
  instance,
}) {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const { push } = useHistory();
  const formLoaded = useIndexTableForm(method, id);

  const [actionLoading, setActionLoading] = React.useState(false);

  React.useEffect(() => {
    if (instance) {
      dispatch(
        setActiveFormInstance({
          storeName,
          data: instance,
        })
      );
    }
  }, []);

  const onSubmit = () => {
    setActionLoading(true);

    if (method === "POST") {
      dispatch(
        create({
          successCallback: (_, returned) => {
            setActionLoading(false);
            push(detailUrl({ id: returned.id }));
          },
          errorCallback: () => {
            setActionLoading(false);
          },
        })
      );
    } else {
      dispatch(
        update({
          id,
          successCallback: (_, returned) => {
            setActionLoading(false);
            closeFunction();
          },
          errorCallback: () => {
            setActionLoading(false);
          },
        })
      );
    }
  };

  const loading = !formLoaded || actionLoading;
  return (
    <Modal
      closeFunction={closeFunction}
      title={
        method === "POST" ? "Skapa ny indextabell" : "Uppdatera indextabell"
      }
      acceptTitle={"Spara"}
      onAccept={onSubmit}
    >
      {loading && <OverlaySpinner />}

      <div className="mb-6 grid grid-cols-2 gap-6">
        <TextInputField
          title="Namn på tabell"
          fieldKey="title"
          {...{ method, storeName }}
        />
      </div>

      <div className="mb-6 ">
        <CheckField
          title="Använd senaste registrerade värde vid tom period"
          description="Om denna inställning är aktiv för tabellen så kommer systemet automatiskt att använda sig av det senast inlagda värdet om en period har missats att läggas in"
          fieldKey="assume_previous_value"
          {...{ method, storeName }}
        />
      </div>
    </Modal>
  );
}
